export let JobStatus = /*#__PURE__*/function (JobStatus) {
  JobStatus["Worker"] = "worker";
  JobStatus["Freelance"] = "freelance";
  return JobStatus;
}({});